<template>
	<!--基础的input-->
	<div class="posi-relative select-box">
		<input type="password" :id='id' :value='val' :class="classCpt" :style="styleCpt" :maxlength="maxlength"
		   :placeholder="placeholder" :autofocus="autofocus" @click="$emit('click')"
		   v-on="inputListeners" />
		<select name="">
		   	<option value=""></option>
		</select>
		<span v-if="isSpanShow" class="fa fa-plus-circle posi-absolute" @click="removeValue($event)"></span>
		<span v-if="isSpanShow" class="fa fa-eye posi-absolute"></span>
	</div>
</template>

<script>
	export default{
		inheritAttrs: false, //根元素不继承特性
		mounted(){
			let that = this;
			//如果设定了宽度
			if(this.widthCpt){ 
				this.styleCpt = 'width:' + this.widthCpt;
			}
			 
		},
		props:['id','value','widthCpt','classCpt','placeholder',
			   'autofocus','readonly','maxlength','onmousewheel'],
		data(){
			return{
				styleCpt:'', //input 样式
				val:'', //输入框的值
				isSpanShow:false // 是否显示清除 和 展示密码操作
			}
		},
		methods:{
			//点击清除操作
			removeValue:function(e){
				this.val = '' ;
				this.isSpanShow = false;
				//获得当前的点击的 
				let str = e.target.className.split('posi-absolute')[0].split('fa ')[1];
				$('.'+str).siblings('input').focus(); // 获得焦点
			}
		},
		computed:{
			inputListeners:function(){
				let vm = this;
				//Object.assign 将所有的对象合并为一个新对象
				return Object.assign(
					{},
					// 我们从父级添加所有的监听器
					this.$listeners,
					//然后我们添加定义监听器，或覆写一些监听器行为
					{
						// 这里确保组件配合 `v-model` 的工作
				        input: (event) => {
				        	//用户输入时
				        	vm.val = event.target.value;
				        	if( event.target.value != '' ){
				        		vm.isSpanShow = true;
				        	}else{
				        		vm.isSpanShow = false;
				        	}
				            vm.$emit('input', event.target.value)
				        },
				        //获得焦点事件
				        onfocus: () => { vm.$emit('onfocus') },
				        //失去焦点事件
				        onblur: () => { vm.$emit('onblur') },
					}
				)
			}
		}
	}
</script>

<style scoped lang='less'>
    .select-box{
        input{ padding-right:3rem; }
        >span{ color:#999; font-size: .87rem; top:.7rem; }
        span:nth-child(2){ right:2.3rem; display: inline-block;transform: rotateZ(45deg);}
        span:nth-child(3){ right:.8rem; }
        span:hover{ color:#A6A6A6; cursor: pointer; display: inline-block;}
    }
</style>


// WEBPACK FOOTER //
// src/components/BaseCpts/selectBase.vue